
import { columns } from '../transcripts-table/constants'

const columnsParams = columns({})
export function getColumnParamsByDataField(dataField) {
  return columnsParams.find(params => params.dataField === dataField)
}
export function getColumnParamsByKeyForRequest(keyForRequest) {
  return columnsParams.find(params => params.keyForRequest === keyForRequest)
}

export function iterateOverFilters(filters, fun) {
  if (!filters) return undefined
  if (filters[0] === '!') {
    return ['!', iterateOverFilters(filters[1], fun)]
  }
  if (typeof filters[0] === 'string') {
    return fun(filters)
  }
  if (Array.isArray(filters[0])) {
    for (let ii = 0; ii < filters.length; ii += 2) {
      filters[ii] = iterateOverFilters(filters[ii], fun)
    }
  }
  return filters
}

export function iterateGroups(groups, fun) {
  if (!groups) return undefined
  groups.forEach((group, ii) => {
    groups[ii] = fun(group)
  })
  return groups
}

function tryFindIdSelectedRow(currentFilterLevel) {
  const [firstPart, logicalOperator, secondPart] = currentFilterLevel
  if (typeof firstPart === 'string') {
    if (firstPart === 'transcriptId' && logicalOperator === '=') {
      return secondPart
    }
  }
  if (Array.isArray(firstPart)) {
    const res = tryFindIdSelectedRow(firstPart)
    if (res) return res
  }
  if (Array.isArray(secondPart)) {
    const res = tryFindIdSelectedRow(secondPart)
    if (res) return res
  }
}
export function isRequestForSelectedTranscript(filter) {
  if (!filter) return false
  return tryFindIdSelectedRow(filter)
}

export function isResponseForGrouping(transcripts) {
  return transcripts[0].key !== undefined
}

/* used for each date separately to take into account clock changes */
export function changeDateToCurrentTimeZone(date, timeZone) {
  if (date === 0) return 0
  const dateObj = new Date(date)
  return +new Date(dateObj.toLocaleString('en-US', { timeZone }))
}
export function changeDateToAccountTimeZone(date, timeZone) {
  if (date === 0) return 0
  const dateObj = new Date(date)
  const diff = new Date(dateObj.toLocaleString('en-US', { timeZone })) - dateObj
  return date - diff
}
